module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/089-sint-maarten-920b058c651606e68ef450e5f07c81a8.svg";